export default {
  contact: {
    hero: {
      eyebrow: 'Kontakt',
      title: 'Obratite nam se',
      lead: 'Bilo prve informacije, konkretno planiranje ili obilazak na licu mjesta – veselimo se vašoj poruci.',
    },
    info: {
      partner: 'Vaš partner za sigurnosnu tehniku',
      owner: 'Vlasnik',
      address: 'Adresa',
      phone: 'Telefon',
      email: 'E-pošta',
      hours: 'Radno vrijeme',
      area: 'Područje djelovanja',
      viewAreas: 'Pogledajte sva područja djelovanja',
    },
    form: {
      title: 'Upit za projekt',
      lead: 'Ispunite obrazac. Javit ćemo vam se uskoro.',
      customerType: 'Privatno ili poslovno *',
      select: 'Molimo odaberite',
      privat: 'Privatno',
      gewerbe: 'Poslovno',
      name: 'Ime *',
      company: 'Tvrtka',
      phone: 'Telefon',
      email: 'E-pošta *',
      projectLocation: 'Lokacija projekta',
      objectType: 'Vrsta objekta',
      objEfh: 'Obiteljska kuća',
      objMfh: 'Višestambena zgrada',
      objLaden: 'Trgovina / dućan',
      objBuero: 'Ured / ordinacija',
      objGastronomie: 'Ugostiteljstvo',
      objLager: 'Skladište / logistika',
      objWerkstatt: 'Radionica / obrt',
      objSonstige: 'Ostalo',
      service: 'Željena usluga',
      svcBeratung: 'Prvo savjetovanje',
      svcPlanung: 'Planiranje i ponuda',
      svcInstallation: 'Ugradnja i postavljanje',
      svcErweiterung: 'Proširenje postojećeg sustava',
      svcWartung: 'Održavanje / skrb',
      svcCare: 'Upit za SSG Care',
      systemStatus: 'Status sustava',
      stNeu: 'Novi sustav',
      stBestehend: 'Proširiti postojeći sustav',
      stAustausch: 'Potpuna zamjena',
      stUnsicher: 'Još nisam siguran',
      message: 'Poruka',
      messagePlaceholder: 'Ukratko opišite svoj projekt ili pitanja...',
      maxChars: 'Najviše 500 znakova',
      fileUpload: 'Prijenos datoteke',
      fileHint: 'Fotografije, nacrti ili drugi dokumenti (opcionalno)',
      fileNote: 'Napomena: prijenosi se tretiraju kao «Uncollectable».',
      callback: 'Poželjno vrijeme povratnog poziva',
      callbackNone: 'Nije poželjan povratni poziv',
      vormittag: 'Prijepodne',
      nachmittag: 'Poslijepodne',
      abend: 'Navečer',
      consent: 'Pročitao/la sam politiku privatnosti i pristajem na obradu svojih podataka za ovaj zahtjev. *',
      success: 'Hvala na vašem upitu. Javit ćemo vam se uskoro.',
      submit: 'Pošalji upit',
      submitting: 'Slanje...',
    },
  },
};